import { vicinitiesOptionsSelector } from '../../recoil/selectors'
import { RenderSchema } from '../../utils/FormRenderer'
import { AssignVicinitiesSchema } from '../../utils/FormSchemas'
import { useRecoilValue } from 'recoil'

export const AssignVicinitiesModal = ({ form, data: { record } }) => {
	const vicinities = useRecoilValue(vicinitiesOptionsSelector)
	return (
		<div className='flex flex-col py-3 px-5 h-full w-full overflow-y-auto content-center'>
			<div>{RenderSchema(AssignVicinitiesSchema({ form, record, vicinities }))}</div>
		</div>
	)
}
